import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteX: {
        id: 'ml.quoteandbind.agent.policySummaryheader.Quote #',
        defaultMessage: 'Quote #: {quoteId}'
    },
    insurancetype: {
        id: 'ml.quoteandbind.agent.policySummaryheader.type',
        defaultMessage: '{type} Policy'

    },
    umbrella: {
        id: 'ml.quoteandbind.agent.policySummary.Umbrella',
        defaultMessage: 'Umbrella'
    },
    auto : {
        id: 'ml.quoteandbind.agent.policySummary.Auto',
        defaultMessage: 'Auto'
    },
    policyX: {
        id: 'ml.quoteandbind.agent.policySummaryheader.Policy #',
        defaultMessage: 'Policy #: {policyId}'
    },
    perTermAnnual: {
        id: 'ml.quoteandbind.agent.policySummaryheader.perTermAnnual',
        defaultMessage: '/ year'
    },
    perTerm6Month: {
        id: 'ml.quoteandbind.agent.policySummaryheader.perTerm6Month',
        defaultMessage: '/ 6 month'
    },
    perTerm7day: {
        id: 'ml.quoteandbind.agent.policySummaryheader.perTerm7day',
        defaultMessage: '/ 7 days'
    },
    namedNonOwenr : { 
        id: 'ml.quoteandbind.agent.policySummaryheader.Named Non-Owner',        
        defaultMessage: 'Named Non-Owner'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.agent.policySummaryheader.Effective Date:',
        defaultMessage: 'Effective Date: '
    },
    expirationDate: {
        id: 'ml.quoteandbind.agent.policySummaryheader.Expiration Date:',
        defaultMessage: 'Expiration Date: '
    },
    namedNonOwnerHeadingNP:{
        id: 'ml.quoteandbind.pa.policySummary.namedNonOwnerHeadingNP',
        defaultMessage: 'Non Owner'
    },
    namedNonOwnerHeading:{
        id: 'ml.quoteandbind.pa.policySummary.namedNonOwnerHeading',
        defaultMessage: 'Named Non Owner '
    }
    
});